import axios from 'axios';
export default {
    async checkParent(regnum) {
        return axios.get(`/api/enduser/check-parent/${regnum}`);
    }
}